export type { ICardColorSchemaLists } from './card-colors/card-colors'
export {
  CardColors,
  cardColorSchemaList,
  productColorSchemaList,
} from './card-colors/card-colors'
export { setComponentColor } from './set-component-color'
